import { moveToFulfilled, moveToPending, moveToRejected, remove } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type { CampaignCreateAction } from '../../domains/campaignCreation/actions.types';

import type { CampaignCreation } from './types';

export type CampaignCreationAction = CampaignCreateAction;

const initialState: CampaignCreation = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<CampaignCreation, CampaignCreationAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'CAMPAIGN.CREATE_REJECTED':
      return moveToRejected(state, [action.payload.campaignCreationId], action.payload.error);
    case 'CAMPAIGN.CREATE_PENDING':
      return moveToPending(state, [action.payload.campaignCreationId]);
    case 'CAMPAIGN.CREATE_FULFILLED':
      return moveToFulfilled(state, { [action.payload.campaignCreationId]: action.payload });
    case 'CAMPAIGN.CREATE_RESET':
      return remove(state, [action.payload.campaignCreationId]);
    default:
      return state;
  }
};

export default reducer;
